export const selectProps = { placeholder: 'Choose one' };
export const selectMultipleProps = { placeholder: 'Choose multiple' };
